import { render, staticRenderFns } from "./PasswordForgottenView.vue?vue&type=template&id=14a56654&scoped=true&"
import script from "./PasswordForgottenView.vue?vue&type=script&lang=js&"
export * from "./PasswordForgottenView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a56654",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a56654')) {
      api.createRecord('14a56654', component.options)
    } else {
      api.reload('14a56654', component.options)
    }
    module.hot.accept("./PasswordForgottenView.vue?vue&type=template&id=14a56654&scoped=true&", function () {
      api.rerender('14a56654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/PasswordForgottenView.vue"
export default component.exports